import { UnitConversionService } from '../../unit-conversion-service';
import { DimensionUnit } from '../../../enums/dimension-unit';

const createDimensions = (dimensions = {}, defaultUnit = DimensionUnit.Inches) => {
  const validDimensions = dimensions || {};
  const dimensionsUnit = validDimensions.unit !== DimensionUnit.Unknown ? validDimensions.unit : defaultUnit;
  return {
    length: validDimensions.length || 0,
    width: validDimensions.width || 0,
    height: validDimensions.height || 0,
    unit: dimensionsUnit || defaultUnit,
  };
};

export const convertDimensions = (dimensions, unit) => {
  const validatedDimensions = createDimensions(dimensions, unit);

  const convertValue = (value) => {
    return UnitConversionService.convertValue(value, validatedDimensions.unit, unit);
  };

  return {
    length: convertValue(validatedDimensions.length),
    width: convertValue(validatedDimensions.width),
    height: convertValue(validatedDimensions.height),
    unit,
  };
};
